﻿// material-ui
import { styled  } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';

// project imports
import { DRAWER_WIDTH } from '../../../config';

import { Theme } from '@mui/material/styles';

const AppBarStyled = styled(AppBar, { shouldForwardProp: (prop: any) => prop !== 'open' })(({ theme }: { theme: any }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: 'none',
  variants: [
    {
      props: ({ open }: { open: any }) => !open,
      style: {
        width: `calc(100% - ${theme.spacing(7.5)})`,
        transition: 'none'
      }
    },
    {
      props: ({ open }: { open: any }) => open,
      style: {
        marginLeft: DRAWER_WIDTH,
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        transition: 'none'
      }
    }
  ]
}));

export default AppBarStyled;

